export default "__VITE_ASSET__msW9kLe5__"